import React from "react";
import Call from "../../Assets/Contact/Call.png";
import Registration from "../../Assets/Contact/Registration.png";
import Location from "../../Assets/Contact/Location.png";

function Card() {
  return (
    <>
      <div
        className="p-6 md:px-24 w-full"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        <h1
          className="text-3xl lg:text-5xl font-medium mb-4 text-center"
          data-aos="fade-up"
        >
          Contact Details
        </h1>
        <div
          className="flex flex-col justify-between p-8 mt-8 bg-[#EAFCFF] items-center border border-[#12D2EC] rounded-md"
          data-aos="flip-down"
        >
          <img src={Call} className="w-14 md:w-24" />

          <div className="grid gap-4 md:grid-cols-3 py-8">
            <div className="items-center flex flex-col text-base md:text-lg">
              <h6 className="text-[#0218DC] font-semibold leading-loose md:leading-normal lg:leading-loose text-center">
                Customer Service Cell
              </h6>

              <div className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                <p>(+91) 8208152163</p>
                <p>(+91) 8093912170</p>
              </div>
            </div>

            <div className="items-center flex flex-col text-base md:text-lg">
              <h6 className="text-[#0218DC] font-semibold leading-loose md:leading-normal lg:leading-loose text-center">
                Mobile
              </h6>

              <div className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed text-center">
                <p>(+91) 8249525997 & 9439199089 (M.D)</p>
              </div>
            </div>

            <div className="items-center flex flex-col text-base md:text-lg">
              <h6 className=" text-[#0218DC] font-semibold leading-loose md:leading-normal lg:leading-loose text-center">
                Telephone Numbers
              </h6>

              <p className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                (0674) 7965811
              </p>
            </div>
          </div>
        </div>

        <div className="relative md:flex justify-center gap-8 mt-4 mb-4">
          <div
            className="flex md:flex flex-col items-center p-8 bg-[#EAFCFF] md:w-[50%] border border-[#12D2EC] rounded-md"
            data-aos="fade-up-right"
          >
            <img src={Registration} alt="" className="w-14 md:w-24" />

            <div className="flex md:flex-row flex-col items-center justify-between lg:gap-10 md:gap-2 p-4 pt-8">
              <div className="flex flex-col items-center md:items-start text-base md:text-lg">
                <span className="text-[#0218DC] font-semibold leading-loose md:leading-normal">
                  GSTIN
                </span>

                <span className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                  21AAECO4214D1Z6
                </span>

                <span className="text-[#0218DC] relative inline-block -ml-2 md:ml-auto font-semibold leading-loose md:leading-normal ">
                  Registration Number
                </span>

                <span className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                  21AAECO4214D1Z6
                </span>
              </div>

              <div className="flex flex-col items-center md:items-start text-base md:text-lg">
                <span className="text-[#0218DC] font-semibold leading-loose md:leading-normal">
                  PAN Number
                </span>

                <span className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                  AAECO4214D
                </span>

                <span className="text-[#0218DC] font-semibold leading-loose md:leading-normal">
                  TAN Number
                </span>

                <span className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed">
                  BBNO03314D
                </span>
              </div>
            </div>
          </div>

          <div
            className="flex md:flex flex-col items-center p-8 mt-4 md:mt-0 bg-[#EAFCFF] md:w-[50%] border border-[#12D2EC] text-sm rounded-md"
            data-aos="fade-up-left"
          >
            <img src={Location} alt="" className="w-14 md:w-24 pb-4" />
            <div className="flex flex-col items-center text-base md:text-lg">
              <h6 className="text-[#0218DC] font-semibold leading-loose md:leading-normal">
                Reach Us
              </h6>

              <span className="text-[#4D4C4C] text-sm md:text-base tracking-wide leading-loose md:leading-relaxed text-center">
                Plot No.822, B3, Kalinga Nagar, Ghatikia, Bhubaneswar, Odisha –
                751003
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
